import React from 'react';

import classes from './FranchizeDescription.module.scss';

const franchizeDescription = props => <p className={classes.FranchizeDescription}>{props.children}</p>;

export default franchizeDescription;